export default "__VITE_ASSET__d163ff5c__"